module.exports = __webpack_public_path__ + "img/logo-portal-ege.840e8532.png";